import { ISectionStyles, useSectionStyles } from '../';

export interface SectionHeaderProps extends React.FormHTMLAttributes<HTMLDivElement> {
    displayWhenEmpty?: boolean;
}

export const SectionHeader: React.FC<SectionHeaderProps> = (props) => {  
    const styles: ISectionStyles = useSectionStyles();
    const className: string = props.className ?? "border-bottom my-3 pt-2 pb-0 w-100";

    if ((props.children === null || props.children === undefined) && (!(props.displayWhenEmpty ?? false))) {
        return null;
    }

    return (
        <div {...props} className={className} style={{ ...styles.header, ...props.style }} />
    );
};